import React from "react";

export default function Person(){
    return(
        <div>
           <h3>Page not found</h3>
        </div>
    )
}